<p>current-detail-template works!</p>
